
export const name = "blog-editor-ui";
export const version = "dev";
